'use client';

import { useAuthModal } from '@/lib/context/AuthModalContext';
import styles from './ProfileDropdown.module.css';

export const UnauthenticatedOptions = () => {
  const { openModal } = useAuthModal();

  return (
    <div className={styles.dropdown}>
      <div className={styles.option} onClick={() => openModal('login')}>Sign in</div>
      <div className={styles.option} onClick={() => openModal('register')}>Create account</div>
    </div>
  )
};